import http from "./httpService";

/** Obtiene las rutas permitidas para un rol (usado con login Microsoft). */
export const getAvailableRoutesByRole = (role) =>
  http.get(`/api/GetAvailableRoutesByRole/${role || ""}`);

export const callActionApiAsync = async (
  apiFunc,
  setData,
  handleError,
  setLoader
) => {
  if (setLoader) setLoader(true);
  try {
    await apiFunc()
      .then(async (response) => {
        if (response) {
          if (setData.constructor.name === "AsyncFunction")
            await setData(response.data);
          else setData(response.data);
        }
      })
      .catch((err) => {
        var error = "";
        if (err.response) {
          if (err.response.data) {
            error = err.response.data;
            console.log("error-response: ", err.response.data);
          } else {
            error = err.response;
            console.log("error-response: ", err.response);
          }
        } else if (err.request) {
          error = err.request;
          console.log("error-request: ", err.request);
        } else {
          error = err;
          console.log("error-error: ", err);
        }

        if (handleError) {
          console.log("handleError: -> ", error);
          handleError(error);
        }
      })
      .then(() => {
        if (setLoader) setLoader(false);
      });
  } catch (e) {
    console.log("error: ", e.message);
  }
};

export const callApiAsync = async (
  apiFunc,
  setData,
  handleError,
  setLoader
) => {
  await callActionApiAsync(apiFunc, setData, handleError, (data) => {
    if (setLoader) setLoader(data);
  });
};

/*Package*/
export const getPackage = (isActive) =>
  http.get(`/api/getPackageList/${isActive}`);
export const packageCreateOrUpdate = (data) =>
  http.post(`/api/packageCreateOrUpdate`, data);
export const deletePackage = (id) => http.delete(`/api/deletePackage/${id}`);
export const getPackageById = (packageId) =>
  http.get(`/api/getPackage/${packageId}`);
export const changePackageStatus = (data) =>
  http.post(`/api/changePackageStatus`, data);

/*Products*/
export const getMainProducts = () => http.get(`/api/getMainProducts`);
export const productCreateOrUpdate = (data) =>
  http.post(`/api/productCreateOrUpdate`, data);

/*Features*/
export const getAllFeatures = () => http.get(`/api/getAllFeatures`);
export const getFeaturesByProduct = (productId, activeOnly = false) =>
  http.get(
    `/api/getFeaturesByProduct/${productId}${activeOnly ? "?activeOnly=true" : ""}`
  );
export const userSysLicenseCreateOrUpdate = (data) =>
  http.post(`/api/userSysLicenseCreateOrUpdate`, data);
export const featuresCreateOrUpdate = (data) =>
  http.post(`/api/featuresCreateOrUpdate`, data);
export const updateFeatureStatus = (data) =>
  http.post(`/api/updateFeatureStatus`, data);
export const deleteFeature = (id) => http.delete(`/api/deleteFeature/${id}`);

/*BusinessUnit*/
export const getBusinessUnits = () => http.get(`/api/getBusinessUnits`);
export const getCsm = () => http.get(`/api/getCsm`);
export const businessUnitCreateOrUpdate = (data) =>
  http.post(`/api/businessUnitCreateOrUpdate`, data);
export const deleteBussinesUnit = (id) =>
  http.delete(`/api/deleteBusinessUnit/${id}`);

/*BillingUnits*/
export const getBillingUnits = () => http.get(`/api/getBillingUnits`);
export const billingUnitsCreateOrUpdate = (data) =>
  http.post(`/api/billingUnitCreateOrUpdate`, data);
export const getSysEnterpriseForBillingUnit = () =>
  http.get(`/api/getSysEnterprise?forBillingUnit=true`);

/*Country*/
export const getCountrys = () => http.get(`/api/GetCountrys`);
export const countryCreateOrUpdate = (data) =>
  http.post(`/api/countryCreateOrUpdate`, data);

/*PricingInstance*/
export const getPricingInstance = (idBillingPeriod, idBusinessUnit) => {
  const params = new URLSearchParams();
  if (idBillingPeriod != null && idBillingPeriod !== "") params.set("idBillingPeriod", idBillingPeriod);
  if (idBusinessUnit != null && idBusinessUnit !== "") params.set("idBusinessUnit", idBusinessUnit);
  const qs = params.toString();
  return http.get(`/api/getPricingInstance${qs ? `?${qs}` : ""}`);
};
export const createUpdatePricingInstance = (data) =>
  http.post(`/api/createUpdatePricingInstance`, data);
export const getEditPricingInstanceData = (idPricingInstance) =>
  http.get(`/api/getEditPricingInstanceData/${idPricingInstance}`);
export const getUsersByBusinessUnit = (businessUnitId) =>
  http.get(`/api/getUsersByBusinessUnit/${businessUnitId}`);
export const getUsersForNewPricingInstance = (params) => {
  const p = new URLSearchParams();
  if (params.idBillingPeriod != null) p.set("idBillingPeriod", params.idBillingPeriod);
  if (params.idPackage != null) p.set("idPackage", params.idPackage);
  if (params.idBusinessUnit != null) p.set("idBusinessUnit", params.idBusinessUnit);
  p.set("temporalAddition", params.temporalAddition ? "1" : "0");
  p.set("temporalRemoval", params.temporalRemoval ? "1" : "0");
  return http.get(`/api/getUsersForNewPricingInstance?${p.toString()}`);
};
export const closeBillingAndCreateNextPeriod = (idBillingPeriod) =>
  http.post(`/api/closeBillingAndCreateNextPeriod`, { idBillingPeriod });
export const deletePricingInstance = (pricingInstanceId) =>
  http.delete(`/api/deletePricingInstance/${pricingInstanceId}`);

/*BillingPeriod*/
export const getBillingPeriodByPackage = (id) =>
  http.get(`/api/getBillingPeriodByPackage/${id}`);
export const createBillingPeriod = (data) =>
  http.post(`/api/createBillingPeriod`, data);

/*BillingPeriod*/
export const getCurrency = () => http.get(`/api/getCurrency`);

/*EnterpriseKey*/
export const getEnterpriseKeyByPackage = (packageId) =>
  http.get(`/api/getEnterpriseKeyByPackage/${packageId}`);

/*SysUsers*/
export const getSysUsers = (enterpriseKey) =>
  http.get(`/api/getSysUsers/${enterpriseKey}`);

/*SysUsers*/
export const getSysEnterprise = () => http.get(`/api/getSysEnterprise`);

/*Billing*/
export const getBillingSelect = () => http.get(`/api/getBillingSelectV2`);
export const getBillingFiltersOnly = () => http.get(`/api/getBillingFiltersOnly`);
export const getBillingPeriodsByBusinessUnit = (businessUnitId) =>
  http.get(`/api/getBillingPeriodsByBusinessUnit/${businessUnitId}`);

/** Periodo inicial: el front envía year/month ya validados (UTC). */
export const createInitialBillingPeriod = (data) =>
  http.post(`/api/createInitialBillingPeriod`, data);

/** Reporte facturación para contador: pricing instances facturados en un periodo (mes/año). */
export const getFacturacionReportExport = (month, year) =>
  http.get(`/api/getFacturacionReportExport?month=${month}&year=${year}`, {
    timeout: 300000,
  });

export const createBillingPeriodV2 = (data) =>
  http.post(`/api/createBillingPeriodV2`, data);

export const getPeriodUserTableData = (data) =>
  http.get(`/api/getPeriodUser/${data}`);

export const getUserByFeatureAndPeriod = (
  featureId,
  billingUnitId,
  bussinesUnitId
) =>
  http.get(
    `/api/UserByFeatureAndPeriod/${featureId}/${billingUnitId}/${bussinesUnitId}`
  );

export const postFeatureToBilling = (data) =>
  http.post(`/api/AddFeatureToBilling`, data);

export const postUserToBilling = (data) =>
  http.post(`/api/AddUserToBilling`, data);

export const getFeaturesBilling = (billingPeriodId, businessUnitId) => {
  return http.get(
    `/api/GetFeaturesBilling/${billingPeriodId}/${businessUnitId}`
  );
};

export const getUsersBilling = (
  billingPeriodId,
  bussinesUnitId,
  featureId
) => {
  return http.get(
    `/api/GetUsersBilling/${billingPeriodId}/${bussinesUnitId}/${featureId}`
  );
};

export const deleteFeaturePeriodUser = (featurePeriodUserId) =>
  http.post(`/api/DeleteFeaturePeriodUser`, featurePeriodUserId);

export const changeBilledFeature = (data) =>
  http.post(`/api/ChangeBilledFeaturePeriodUser`, data);

export const updateFeaturePeriodCall = (data) =>
  http.post(`/api/UpdateFeaturePeriod`, data);

export const getAddittionalCost = (businessUnitId, billingPeriodId) =>
  http.get(`/api/GetIndependentCost/${businessUnitId}/${billingPeriodId}`);

export const createAddittionalCost = (data) =>
  http.post(`/api/independentCostCreateOrUpdate`, data);   

export const postDeleteAddittionalCost = (id) =>
  http.post((`/api/DeleteIndependentCost/${id}`));   

export const getPaymentsByIndependentCost = (independentCostId) =>
  http.get(`/api/GetPaymentsByIndependentCost/${independentCostId}`);

export const createPayment = (data) =>
  http.post(`/api/CreatePayment`, data);

export const deletePayment = (id) =>
  http.post(`/api/DeletePayment/${id}`);

export const GetTotalByBillingPeriod = (billingPeriodId) =>
  http.get(`/api/GetTotalByBillingPeriod/${billingPeriodId}`);

export const getPackagesBilling = (billingPeriodId, businessUnitId) => {
  return http.get(
    `/api/GetBilledPackagePlans/${businessUnitId}/${billingPeriodId}`
  );
};
export const GetActivePackagePlans = (billingPeriodId, businessUnitId) => {
  return http.get(
    `/api/GetActivePackagePlans/${businessUnitId}/${billingPeriodId}`
  );
};

export const CreatePackagePlanPeriod = (data) =>
  http.post(`/api/CreatePackagePlanPeriod`, data);

export const CreatePeriod = (businessUnitId, year, month) => {
  return http.post(
    `/api/CreatePeriod/${businessUnitId}/${year}/${month}`
  );
};

export const deletePackagePlanPeriod = (id) => http.delete(`/api/deletePackagePlanPeriod/${id}`);
 